import { LAB_ACCOUNT_SYSTEMS } from '@/pages/Patient/components/OrderTests/formData'

/**
 * The lab account number fields Super admin offers per organization.
 *
 * One entry per key in `LAB_ACCOUNT_SYSTEMS` — the org form renders an input for each
 * LABEL, so a lab with a system but no label here has a value that is loaded into form
 * state and written back on every save while being impossible to see or edit. Quest sat
 * in exactly that state: `project-configure` seeds a placeholder account number, nothing
 * could replace it, and it printed on real requisitions as `Account #: QD-00001`.
 *
 * Its own module so that parity with `LAB_ACCOUNT_SYSTEMS` can be tested without
 * rendering the whole organization form.
 */
export const LAB_ACCOUNT_LABELS: Record<keyof typeof LAB_ACCOUNT_SYSTEMS, string> = {
  INVITAE: 'Invitae',
  LABCORP: 'Labcorp',
  QUEST: 'Quest Diagnostics',
  ACCU_REFERENCE: 'AccuReference',
  EXACT_SCIENCES: 'Exact Sciences (Cologuard)',
  GTI: 'GTI',
}
